import { ProSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import {
  FaAngellist,
  FaList,
  FaTools,
  FaRegBuilding,
  FaAngular,
  FaUsers,
  FaBlogger,
  FaAudible,
  FaCcAmex,
  FaCodiepie
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  setToggled,
  selectToggled,
  selectSession,
  handleField,
  handleFieldCompany,
  handleFieldAvatar,
  handleFieldCompanyName,
  handleFieldRol
} from '../features/shopBicycleState/shopBicycleSlice';
import * as ROUTES from '../utils/urls';
import { useTranslation } from 'react-i18next';
import { useWindowWidth } from '@react-hook/window-size';
import { ContainerNab } from '../assets/styles';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const Navbar = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('translation');
  const dispatch = useDispatch();
  const onlyWidth = useWindowWidth();
  const session = useSelector(selectSession);

  let toggled = useSelector(selectToggled);
  // const [session, setSession] = useState({})


  const key = 'toggled';

  const menuIconClick = () => {
    dispatch(setToggled({ key, toggled }));
  };

  const handleLogout = () => {
    localStorage.setItem('isLogged', 'false');
    localStorage.setItem('user', null);
    {
      const value = '';
      dispatch(handleField({ value }));
    }

    {
      const value = undefined;
      dispatch(handleFieldCompany({ value }));
    }
    {
      const value = undefined;
      dispatch(handleFieldRol({ value }));
    }
    navigate('/login');
  };

  useEffect(() => {
    const handleChange = (value) => {
      dispatch(handleField({ value }));
    };
    const handleChangeCompany = (value) => {
      dispatch(handleFieldCompany({ value }));
    };
    const handleChangeCompanyName = (value) => {
      dispatch(handleFieldCompanyName({ value }));
    };

    const handleChangeAvatar = (value) => {
      dispatch(handleFieldAvatar({ value }));
    };

    const handleChangeRol = (value) => {
      dispatch(handleFieldRol({ value }));
    };

    let userObject = JSON.parse(localStorage.getItem("user"))
    userObject?.companyId && handleChangeCompany(userObject?.companyId);

    userObject?.companyName && handleChangeCompanyName(userObject?.companyName);
    userObject?.rol && handleChangeRol(userObject?.rol);
    userObject?.avatar && handleChangeAvatar(userObject?.avatar);
    userObject?.name && handleChange(userObject?.name);
  }, [])

  return (
    <ContainerNab>
      <ProSidebar collapsed={onlyWidth > 800 ? toggled : true} width={'200px'}>
        <Menu iconShape="square">
          {session?.name ? (
            <>
              <MenuItem>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column'
                  }}
                >
                  <img
                    style={{
                      width: 80,
                      height: 80,
                      margin: '10px auto',
                      borderRadius: '100px'
                    }}
                    src={
                      session?.avatar
                        ? session.avatar
                        : 'https://firebasestorage.googleapis.com/v0/b/sifone-app-cc2a8.appspot.com/o/media%2Favatar-g3c53b2a4e_1280.png?alt=media&token=eb90a6ca-2782-412e-94b5-032694fa051b'
                    }
                  />
                  <p style={{ fontWeight: 'bold', textAlign: 'center', fontSize: 14, color: 'white', marginTop: 10 }}>
                    {session?.name ? session?.name : 'Buen dia.'}
                  </p>
                </div>
              </MenuItem>
            </>
          ) : (
            <MenuItem>
              <div
                style={{
                  widt: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column'
                }}
              >
                <img
                  alt="logo"
                  style={{ width: 120, margin: '30px auto' }}
                  src={
                    'https://firebasestorage.googleapis.com/v0/b/sifone-app-cc2a8.appspot.com/o/media%2FLogo-Sifone-verde.png?alt=media&token=f66f6e8e-89be-4f5d-93c2-1ef2551c4a30'
                  }
                />
              </div>
            </MenuItem>
          )}
          <MenuItem style={{ fontSize: 13, color: 'white' }} icon={<FaList />}>
            {t('news')}
            <Link to="/" />
          </MenuItem>
          <MenuItem style={{ fontSize: 13, color: 'white' }} icon={<FaAngular />}>
            {t('who')} <Link to="/quienes-somos" />
          </MenuItem>

          {!session?.name ? (
            <MenuItem style={{ fontSize: 13, color: 'white' }} icon={<FaAudible />}>
              Iniciar sesión
              <Link to="/login" />
            </MenuItem>
          ) : (
            <SubMenu style={{ fontSize: 13, color: 'white' }} title={t('group-by-card.admin')} icon={<FaTools />}>
              {session?.name && (
                <>
                  {session?.rol === 'admin' && (
                    <SubMenu style={{ fontSize: 13, color: 'white' }} title={'Empresas'} icon={<FaRegBuilding />}>
                      <MenuItem style={{ fontSize: 13, color: 'white' }}>
                        Crear Empresa
                        <Link to="/company" />
                      </MenuItem>
                      <MenuItem style={{ fontSize: 13, color: 'white' }}>
                        Lista empresas
                        <Link to="/list-companies" />
                      </MenuItem>
                    </SubMenu>
                  )}

                  <SubMenu style={{ fontSize: 13, color: 'white' }} title={'Noticias'} icon={<FaCcAmex />}>
                    <MenuItem>
                      {t('add-news')}
                      <Link to={ROUTES.RENT_FORM} />
                    </MenuItem>
                    <MenuItem style={{ fontSize: 13, color: 'white' }}>
                      Lista de noticias
                      <Link to={'/new-list'} />
                    </MenuItem>
                  </SubMenu>
                  <SubMenu style={{ fontSize: 13, color: 'white' }} title={'Usuarios'} icon={<FaUsers />}>
                    <MenuItem>
                      Crear Usuario
                      <Link to="/users" />
                    </MenuItem>
                    <MenuItem style={{ fontSize: 13, color: 'white' }}>
                      Lista Usuarios
                      <Link to="/list" />
                    </MenuItem>
                  </SubMenu>
                  <SubMenu style={{ fontSize: 13, color: 'white' }} title={'Secciones'} icon={<FaAngellist />}>
                    <MenuItem>
                      Crear Sección
                      <Link to="/admin-quienes-somos" />
                    </MenuItem>
                    <MenuItem style={{ fontSize: 13, color: 'white' }}>
                      Lista secciones
                      <Link to="/we-list" />
                    </MenuItem>
                  </SubMenu>
                  <SubMenu style={{ fontSize: 13, color: 'white' }} title={'Notificaciones'} icon={<FaCodiepie />}>
                    <MenuItem style={{ fontSize: 13, color: 'white' }}>
                      Notificar usuarios
                      <Link to="/notification" />
                    </MenuItem>
                  </SubMenu>
                </>
              )}
            </SubMenu>
          )}

          {session?.name && (
            <MenuItem style={{ fontSize: 13, color: 'white' }} icon={<FaBlogger />} onClick={handleLogout}>
              Logout
            </MenuItem>
          )}

        </Menu>
      </ProSidebar>
    </ContainerNab>
  );
};
export default Navbar;
